module.exports = __webpack_public_path__ + "static/logo-8e49f3a889e3cec545d631a00e95cca8.png";